import script from "./ApolicesRepository.vue?vue&type=script&lang=js"
export * from "./ApolicesRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__